import type { BloomTheme } from '@jane/business-admin/data-access';

export type LoginPrompt = NonNullable<BloomTheme['login_prompt']>;

// Keep in sync with Bloom's signInPromptTheme.ts DEFAULTS so the admin form
// matches what Bloom renders for an unconfigured prompt.
export const DEFAULTS: LoginPrompt = {
  header: 'Get more with a free account!',
  desktop_line_1: 'Fast, secure checkout',
  desktop_line_2: 'Personalized recommendations',
  desktop_line_3: 'View order history anytime',
  mobile_header: 'Get more with a free account!',
  mobile_copy:
    'Enjoy fast, secure mobile checkout, personalized recommendations, and view order history anytime.',
  cta_label: 'Sign up or sign in',
  colors: {
    button: null,
    button_text: null,
  },
};

export type TextFieldName = keyof Omit<LoginPrompt, 'colors'>;
